import { IErrorInfo } from "../services/authority.service";
import { ApiException } from "../services/common/ApiException";

export interface ILocalizedError {
  id?: string | undefined;
  defaultMessage: string | undefined;
  parameters?: string[] | undefined;
}

export function LocalizeMessage(error: any): ILocalizedError {
  const unknownError = "Unknown error occurred";

  if (typeof error === "string") {
    return { defaultMessage: error };
  }

  const errorInfo = error as IErrorInfo;
  if (errorInfo && errorInfo.error) {
    return { id: errorInfo.error, defaultMessage: errorInfo.error_description };
  }

  const exception = error as ApiException;
  if (exception) {
    return { defaultMessage: `[${exception.status}] ${exception.message}`, id: 'unknown' };
  }



  return { defaultMessage: unknownError };
}



// WEBPACK FOOTER //
// ./src/i18n/error-localization.ts